import Header from "./Header";
import SearchInput from "./SearchInput";
import Footer from "./Footer";
import Loading from "./Loading";
import theme from "../styles/theme";
import Modal from "react-bootstrap/Modal";
import calendar from "../assets/icons/calendar.svg";
import compass from "../assets/icons/compass.svg";
import multiple from "../assets/icons/multiple-documents.svg";
import easel from "../assets/icons/easel.svg";
import LeftPane from "./LeftPane";
import FeedbackPopup from "./FeedbackPopup";
import Analytics from "./Analytics";
import PageNumbers from "./PageNumbers";
import useSearchResults from "../custom-hooks/useSearchResults";
import SimplePdfViewerModal from "./SimplePdfViewerModal"; // Import the new modal
import "../styles/search-results.css";
import { SEMANTIC_SEARCH_FEATURE_ENABLED } from "../config/featureFlags";

const PAGINATION_RANGE = 2;

const SearchResults = () => {
  const {
    searchString,
    originalSearchString,
    setSearchResults,
    setSearchResultSets,
    setAnalytics,
    currentPage,
    setCurrentPage,
    loading,
    setLoading,
    collNameIdentifier,
    collSourceCounts,
    collLocationCounts,
    displayedRows,
    totalPages,
    handlePageChange,
    ragSummary,
    setRagSummary,
    handleShow,
    handleClose,
    show,
    handleRowClick,
    selectedRow,
    modalOpen,
    handleCloseModal,
    handleAnalyticsClick,
    analyticsModalOpen,
    handleCloseAnalyticsModal,
    handleHeadingClick,
    sortArrowElement,
    isNewUser,
    fingerprint,
    showFeedbackPopup,
    handleCloseFeedbackPopup,
    setShow,
    setAnalyticsModalOpen,
    visitedRows,
    filtersResetToken,
  } = useSearchResults();

  

  return (
    <>
      <Loading isLoading={loading}>
        <div
          style={{ background: theme.colors.mainGrayBackground, width: "100%" }}
        >
          <Header />
          <div>
            <SearchInput
              searchString={searchString}
              originalSearchString={originalSearchString}
              setSearchResults={setSearchResults}
              setSearchResultSets={setSearchResultSets}
              setAnalytics={setAnalytics}
              setCurrentPage={setCurrentPage}
              setLoading={setLoading}
              setRagSummary={
                SEMANTIC_SEARCH_FEATURE_ENABLED ? setRagSummary : undefined
              }
            />
          </div>

          {SEMANTIC_SEARCH_FEATURE_ENABLED && ragSummary && (
            <div className="rag-summary">
              <h4>Semantic summary</h4>
              <p>{ragSummary}</p>
            </div>
          )}

          <br></br>
          <div className="filters">
            <div
              className="row g-0"
              style={{ display: "flex", alignItems: "center" }}
            >
              <button className="filter-button" onClick={handleShow}>
                <b>Filters</b>
              </button>
            </div>

            <button className="analytics-button" onClick={handleAnalyticsClick}>
              <img
                style={{
                  width: "20px",
                  height: "20px",
                }}
                alt=""
                src={easel}
              />
              <b>Analytics</b>
            </button>
            <Analytics
              show={analyticsModalOpen}
              handleClose={handleCloseAnalyticsModal}
            />
          </div>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton dir="ltr">
              <Modal.Title className="filter-modal-title">Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
          <div className="row g-0 mt-4 ml-2 left-pane-modal">
                <LeftPane
                  btn={false}
                  setShow={setShow}
                  searchString={searchString}
                  setSearchResults={setSearchResults}
                  setSearchResultSets={setSearchResultSets}
                  setAnalytics={setAnalytics}
                  setCurrentPage={setCurrentPage}
                  collNameIdentifier={collNameIdentifier}
                  collSourceCounts={collSourceCounts}
                  collLocationCounts={collLocationCounts}
                  setAnalyticsModalOpen={setAnalyticsModalOpen}
                  setLoading={setLoading}
                  filtersResetToken={filtersResetToken}
                  setRagSummary={
                    SEMANTIC_SEARCH_FEATURE_ENABLED ? setRagSummary : undefined
                  }
                />
              </div>
            </Modal.Body>
          </Modal>

          <div className="row g-0 mt-4 ml-2 results-layout">
            <div className="left-pane col-3 g-0 desktop-left-pane">
              <LeftPane
                btn={true}
                searchString={searchString}
                setSearchResults={setSearchResults}
                setSearchResultSets={setSearchResultSets}
                setAnalytics={setAnalytics}
                setCurrentPage={setCurrentPage}
                collNameIdentifier={collNameIdentifier}
                collSourceCounts={collSourceCounts}
                collLocationCounts={collLocationCounts}
                setAnalyticsModalOpen={setAnalyticsModalOpen}
                setLoading={setLoading}
                filtersResetToken={filtersResetToken}
                setRagSummary={
                  SEMANTIC_SEARCH_FEATURE_ENABLED ? setRagSummary : undefined
                }
              />
            </div>
            <div className="col g-0 results-table-col">
              {displayedRows?.length === 0 ? <div className="container-fluid text-center">No results found. Try searching a different word or phrase</div> :
              <div className="search-results-table-container">
                <table className="table">
                  <thead className="table-head">
                    <tr className="table-header-row">
                      <th className="table-th format-col">
                        Format
                      </th>
                      <th 
                        className="table-th title-col" 
                        onClick={() => handleHeadingClick("title")}
                      >
                        Title
                        <span>{sortArrowElement("title")}</span>
                      </th>
                      <th 
                        className="table-th date-col" 
                        onClick={() => handleHeadingClick("date")}
                      >
                        Date
                        <span>{sortArrowElement("date")}</span>
                      </th>
                      <th 
                        className="table-th location-col" 
                        onClick={() => handleHeadingClick("coll_location")}
                      >
                        Location
                        <span>{sortArrowElement("coll_location")}</span>
                      </th>
                      <th 
                        className="table-th source-col" 
                        onClick={() => handleHeadingClick("coll_source")}
                      >
                        Source
                        <span>{sortArrowElement("coll_source")}</span>
                      </th>
                      <th 
                        className="table-th pages-col" 
                        onClick={() => handleHeadingClick("number_of_pages")}
                      >
                        Pages
                        <span>{sortArrowElement("number_of_pages")}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedRows.map((row, index) => (
                      <tr key={index} onClick={() => handleRowClick(row)} className="table-row">
                        <td className="format-col" data-label="Format">
                          {row.coll_type}
                        </td>
                        <td className="title-col" data-label="Title">
                          <div className="col g-0">
                            <div className="row g-0">Page {row.page_number} of</div>
                            <div className={`row g-0 title-text ${visitedRows.has(row.file_url) ? "visited-row" : ""}`}>
                              {row.title}
                            </div>
                          </div>
                        </td>
                        <td className="date-col" data-label="Date">
                          <img
                            src={calendar}
                            className="table-icon"
                            alt="Calendar Icon"
                          />
                          {row.date_of_manuscript}
                        </td>
                        <td className="location-col" data-label="Location">
                          <img
                            src={compass}
                            className="table-icon"
                            alt="Compass Icon"
                          />
                          {row.coll_location}
                        </td>
                        <td className="source-col" data-label="Source">
                          <img
                            src={multiple}
                            className="table-icon"
                            alt="Multiple Icon"
                          />
                          {row.coll_source}
                        </td>
                        <td className="pages-col" data-label="Pages">
                          <img
                            src={multiple}
                            className="table-icon"
                            alt="Multiple Icon"
                          />
                          {row.number_of_pages}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>  
              </div>
            }
              {/* <PdfViewerModal
                className="pdf-viewer-modal"
                show={modalOpen}
                handleClose={handleCloseModal}
                searchQuery={searchString}
                row={selectedRow}
              /> */} 

              <SimplePdfViewerModal
                show={modalOpen}
                handleClose={handleCloseModal}
                selectedRow={selectedRow}
                searchQuery={searchString}
              />
              {/* Analytics Modal */}
              <Analytics
                show={analyticsModalOpen}
                handleClose={handleCloseAnalyticsModal}
              />
              <div className="row mt-5 mb-5 g-0">
                <div className="d-flex justify-content-center">
                  <PageNumbers
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                    PAGINATION_RANGE={PAGINATION_RANGE}
                  />
                </div>
              </div>
            </div>
          </div>
          {isNewUser !== null && isNewUser && (
            <FeedbackPopup
              show={showFeedbackPopup}
              handleClose={handleCloseFeedbackPopup}
              fingerprint={fingerprint}
            />
          )}
        </div>
        <Footer bgcolor="#FFFFFF" />
      </Loading>
    </>
  );
};

export default SearchResults;
